import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'
import { schema, normalize } from 'normalizr'

const normalizeMedia = data => {
  const media = new schema.Entity('media')
  return normalize(data, [media])
}

const WorkUpload = combineReducers({
  addMediaRequest: createRequestReducer('WORK_UPLOAD:ADD_MEDIA'),
  deleteWorkRequest: createRequestReducer('WORK_UPLOAD:DELETE_WORK'),
  rotateMediumRequest: createRequestReducer('WORK_UPLOAD:ROTATE_MEDIUM'),
  saveWorkRequest: createRequestReducer('WORK_UPLOAD:SAVE'),
  work: createReducer(null, {
    'WORK_UPLOAD:FETCH_REQUEST': () => null,
    'WORK_UPLOAD:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.work
  }),
  media: createReducer(null, {
    'WORK_UPLOAD:FETCH_REQUEST': () => null,
    'WORK_UPLOAD:FETCH_REQUEST_SUCCESS': (state, { response }) => {
      return normalizeMedia(response.data.work.media)
    },
    'WORK_UPLOAD:ADD_MEDIA_REQUEST_SUCCESS': (state, { response }) => {
      const media = response.data.media
      const newState = {
        entities: { media: { ...state.entities.media } },
        result: [...state.result]
      }

      media.forEach(item => {
        newState.entities.media[item.id] = item
        newState.result.push(item.id)
      })

      return newState
    },
    'WORK_UPLOAD:DELETE_MEDIA_REQUEST': (state, { params }) => {
      return {
        ...state,
        result: state.result.filter(id => id !== params.id)
      }
    },
    'WORK_UPLOAD:ROTATE_MEDIUM_REQUEST_SUCCESS': (state, { response }) => {
      return {
        ...state,
        entities: {
          media: {
            ...state.entities.media,
            [response.data.medium.id]: response.data.medium
          }
        }
      }
    },
    'WORK_UPLOAD:REORDER_MEDIA_REQUEST': (state, { params }) => {
      const mediaCopy = { ...state.entities.media }
      params.ids.forEach((id, index) => {
        mediaCopy[id].order = index
      })
      return {
        ...state,
        entities: {
          media: mediaCopy
        }
      }
    }
  })
})

export default WorkUpload
